<template>
  <div class="template-choice-cards">
    <button
      type="button"
      class="template-choice-cards__card template-choice-cards__card--ai"
      @click="$emit('select-ai')"
    >
      <span class="template-choice-cards__icon">
        <BaseIcon name="ai" />
      </span>
      <span class="template-choice-cards__title">
        {{ $t('page.admin-tenant-profile.create-choice.ai-title') }}
      </span>
      <span class="template-choice-cards__subtitle">
        {{ $t('page.admin-tenant-profile.create-choice.ai-subtitle') }}
      </span>
    </button>

    <button
      type="button"
      class="template-choice-cards__card template-choice-cards__card--manual"
      @click="$emit('select-manual')"
    >
      <span class="template-choice-cards__icon">
        <BaseIcon name="edit-2" />
      </span>
      <span class="template-choice-cards__title">
        {{ $t('page.admin-tenant-profile.create-choice.manual-title') }}
      </span>
      <span class="template-choice-cards__subtitle">
        {{ $t('page.admin-tenant-profile.create-choice.manual-subtitle') }}
      </span>
    </button>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';

export default {
  name: 'TemplateChoiceCards',
  components: { BaseIcon },
};
</script>

<style lang="scss">
.template-choice-cards {
  display: flex;
  flex-wrap: wrap;
  gap: $space-md;
  width: 100%;
  max-width: 760px;

  &__card {
    flex: 1 1 280px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: $space-1;
    text-align: left;
    padding: $space-lg;
    border-radius: $radius-lg;
    border: 1px solid transparent;
    cursor: pointer;
    transition: background $duration-fast $ease-ui-interaction, border-color $duration-fast $ease-ui-interaction;

    &:focus-visible {
      outline: 2px solid $color-accent;
      outline-offset: 2px;
    }

    // Bold AI tone: purple gradient surface with white content.
    &--ai {
      background: $gradient-ai;
      color: $color-white;

      &:hover {
        background: $gradient-ai-hover;
      }

      .template-choice-cards__subtitle {
        color: rgba($color-white, 0.85);
      }
    }

    // Manual: low-emphasis outlined surface.
    &--manual {
      background: $color-surface-raised;
      border-color: $color-border;
      color: $color-text-title;

      &:hover {
        border-color: $color-accent;
        background: $color-surface-sunken;
      }
    }
  }

  &__icon {
    display: inline-flex;
    margin-bottom: $space-sm;

    .base-icon {
      width: 22px;
      height: 22px;
    }
  }

  &__title {
    @include text-style('body-md');
    font-weight: $font-weight-medium;
  }

  &__subtitle {
    @include text-style('body-sm');
    color: $color-text-muted;
  }
}
</style>
